import React from 'react'

import { Button } from '@acorns/web-components'
import { useAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'

import { useSetRecapPublicAccessMutation } from 'generated/types'
import { ENABLE_SHARING_MODAL } from 'utils/testing/testIDs'

import { ACTIONS, shareAnalyticsOptions } from '../analytics'
import CustodianRecapQuery from '../gql/queries/custodianRecap.gql'
import {
  ButtonWrapperRowGrid,
  ModalContent,
  ModalHeader,
  ModalSubtext,
  ModalText,
} from './styled-components'

export const EnableShareModal = ({
  beneficiaryName,
  recapId,
  onDismiss,
}: {
  beneficiaryName: string
  recapId: string
  onDismiss: () => void
}): React.ReactElement => {
  const analytics = useAnalyticsClient()
  const { getRemoteString } = useRemoteStrings()
  const [setRecapPublicMutation, { loading }] = useSetRecapPublicAccessMutation(
    {
      refetchQueries: [
        {
          query: CustodianRecapQuery,
          variables: {
            id: recapId,
          },
        },
      ],
      awaitRefetchQueries: true,
    },
  )

  const handleEnablePublic = () => {
    setRecapPublicMutation({
      variables: {
        recapId,
        enablePublic: true,
      },
    })

    analytics.track(ACTIONS.BUTTON_TAPPED, {
      ...shareAnalyticsOptions,
      event_description:
        'Early Quarterly Recaps Share Modal Enable Public Link Tapped',
      object_name: 'earlyQuarterlyRecapShareModalEnablePublicLink',
    })
  }

  return (
    <ModalContent data-testid={ENABLE_SHARING_MODAL}>
      <ModalHeader>
        {getRemoteString({ key: 'early.recap.potential.drawer.header' })}
      </ModalHeader>
      <ModalText>
        {getRemoteString({
          key: 'early.recap.potential.drawer.body.variable',
          variables: [beneficiaryName],
        })}
      </ModalText>
      <ModalSubtext>
        {getRemoteString({ key: 'early.recap.potential.drawer.footer' })}
      </ModalSubtext>
      <ButtonWrapperRowGrid>
        <Button onPress={handleEnablePublic} disabled={loading}>
          {getRemoteString({ key: 'early.recap.potential.drawer.cta.enable' })}
        </Button>
        <Button onPress={onDismiss} styleType="flat" secondary>
          {getRemoteString({ key: 'early.recap.potential.drawer.cta.dismiss' })}
        </Button>
      </ButtonWrapperRowGrid>
    </ModalContent>
  )
}
